import { Status } from "../constants";

export interface ITemplateMetadata {
  templateReqHeading?: boolean;
  templateReqMessage?: boolean;
  templateReqIcon?: boolean;
  templateReqLogo?: boolean;
  templateReqZipCode?: boolean;
  firmwareVersion?: string;
  maxAlertMessageCharacter?: number;
  maxAlertTitleCharacter?: number;
  maxAlertMessageLine?: number;
}

export interface ITemplate {
  templateId: number;
  name: string;
  imageUrl?: string;
  public?: boolean;
  metadata?: ITemplateMetadata;
  _id?: string;
}

export interface IAddTemplatePayload {
  name: string;
  file: File | null;
  public: boolean;
  templateId?: number;
  templateReqHeading: boolean;
  templateReqMessage: boolean;
  templateReqIcon: boolean;
  templateReqLogo: boolean;
  templateReqZipCode: boolean;
  firmwareVersion: string;
  maxAlertMessageCharacter?: number;
  maxAlertTitleCharacter?: number;
  maxAlertMessageLine?: number;
}

export interface IUpdateTemplatePayload extends IAddTemplatePayload {
  templateId: number;
}

export const emptyTemplateForm: IAddTemplatePayload = {
  name: "",
  file: null,
  public: true,
  templateId: undefined,
  templateReqHeading: false,
  templateReqMessage: true,
  templateReqIcon: false,
  templateReqLogo: false,
  templateReqZipCode: false,
  firmwareVersion: "",
  maxAlertMessageCharacter: undefined,
  maxAlertTitleCharacter: undefined,
  maxAlertMessageLine: undefined,
};

export const templateToForm = (template: ITemplate): IAddTemplatePayload => ({
  name: template.name || "",
  file: null,
  public: !!template.public,
  templateId: template.templateId,
  templateReqHeading: !!template.metadata?.templateReqHeading,
  templateReqMessage: !!template.metadata?.templateReqMessage,
  templateReqIcon: !!template.metadata?.templateReqIcon,
  templateReqLogo: !!template.metadata?.templateReqLogo,
  templateReqZipCode: !!template.metadata?.templateReqZipCode,
  firmwareVersion: template.metadata?.firmwareVersion || "",
  maxAlertMessageCharacter: template.metadata?.maxAlertMessageCharacter,
  maxAlertTitleCharacter: template.metadata?.maxAlertTitleCharacter,
  maxAlertMessageLine: template.metadata?.maxAlertMessageLine,
});

export interface ITemplatesState {
  templates: ITemplate[];
  orgTemplates: ITemplate[];
  status: string;
  addStatus: string;
  updateStatus: string;
  assignStatus: string;
  inFlight: number;
  error: string | null;
}

export const initialTemplatesState: ITemplatesState = {
  templates: [],
  orgTemplates: [],
  status: Status.IDLE,
  addStatus: Status.IDLE,
  updateStatus: Status.IDLE,
  assignStatus: Status.IDLE,
  inFlight: 0,
  error: null,
};
